import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Button} from 'semantic-ui-react';
import {Actions} from '../../../common/actions';

class ExportButton extends Component {
  constructor(props) {
    super(props);
    this.handleExportClick = this.handleExportClick.bind(this);
  }

  handleExportClick() {
    const {initialDate, finalDate, reason, partCode, agency, user, dealer} = this.props;
    this.props.fetchDownloadLostSalesReportDetail({
      initialDate, finalDate, reason, partCode, agency, user, dealer,
    });
  }

  render() {
    const {loadingAgencies, loading} = this.props;

    return (
      <Button primary
        content='EXPORTAR A EXCEL'
        disabled={loading || loadingAgencies}
        loading={loading}
        onClick={this.handleExportClick}
      />
    );
  }
}

const mapStateToProps = (state) => {
  const {loading, downloading} = state.lostSalesReportDetail;

  return {
    'loading': loading || downloading,
    'loadingAgencies': state.dealer.loading || state.dealer.loadingAgencies,
    'initialDate': state.lostSalesReportDetail.initialDate,
    'finalDate': state.lostSalesReportDetail.finalDate,
    'dealer': state.lostSalesReportDetail.dealer,
    'agency': state.lostSalesReportDetail.agency,
    'user': state.lostSalesReportDetail.user,
    'reason': state.lostSalesReportDetail.reason,
    'partCode': state.lostSalesReportDetail.partCode,
  };
};

const {fetchDownloadLostSalesReportDetail} = Actions;

export default connect(mapStateToProps, {
  fetchDownloadLostSalesReportDetail,
})(ExportButton);
